import { Alert, Platform } from 'react-native';
import * as FileSystem from 'expo-file-system';
const Decimal = require('decimal.js');
import { parse } from 'mathjs';
export const urlFileToBase64 = async (urlFile) =>{
    const data = await fetch(urlFile);
        const blob = await data.blob();
        const reader = new FileReader();
        
        return await (new Promise((resolve,reject)=>{
            reader.readAsDataURL(blob);
            reader.onloadend = () => {
                resolve(reader.result);
            };
        }))    
}
export async function saveLastSync(lastSyncPath:string) {
  try {
    const timestamp = new Date().toISOString(); // formato legible universal}
    if(Platform.OS==="web"){
        localStorage.setItem(lastSyncPath, timestamp);
        const content = localStorage.getItem(lastSyncPath);
        console.log('Última sincronización registrada (web):', content);
        return content;
    }
    await FileSystem.writeAsStringAsync(lastSyncPath, timestamp);
    console.log('Última sincronización guardada:', timestamp);
  } catch (error) {
    console.error('Error al guardar lastSync:', error);
  }
}
export async function readLastSync(lastSyncPath:string) {
  try {
    if(Platform.OS==="web"){
        localStorage.getItem(lastSyncPath);
        const content = localStorage.getItem(lastSyncPath);
        console.log('Última sincronización registrada (web):', content);
        return content;
    }
        
    const fileInfo = await FileSystem.getInfoAsync(lastSyncPath);

    if (!fileInfo.exists) {
      console.log('No existe el archivo de lastSync');
      return null;
    }

    const content = await FileSystem.readAsStringAsync(lastSyncPath);
    console.log('Última sincronización registrada:', content);
    return content;
  } catch (error) {
    console.error('Error al leer lastSync:', error);
    return null;
  }
}

export const calcularVelocidadConexion = async (setSpeedTest:any,statusStore:any) => {
    const inicioTiempo = new Date().getTime();
    const archivo = "https://field.voolks.com/images/speedTest.jpg?inicio=".concat(inicioTiempo.toString()); // URL de un archivo de prueba

    try {
        statusStore.setStatus("pending");
        statusStore.addLoadingInfo({ title: "Calculando tiempo de descarga del servidor", spinner: true })
        const response = await fetch(archivo);
        await response.blob();
        const finTiempo = new Date().getTime();
        const tiempoTotal = finTiempo - inicioTiempo;
        const velocidadBytes = response.headers.get('Content-Length') / (tiempoTotal / 1000); // Calcular la velocidad en bytes por segundo
        const velocidadMbps = (velocidadBytes * 8 / 1000000).toFixed(2); // Convertir a Mbps
        setSpeedTest(velocidadMbps);
        console.log("La velocidad de conexión es: " + velocidadMbps + " Mbps");
        statusStore.clearLoadingInfo();
        statusStore.setStatus("done");
    } catch (error) {
        console.error("Error al cargar la imagen:", error);
    }
};

export const convertImageToBase64 = async (imgUrl, callback) => {
    if (Platform.OS == "web") {
        const image = new Image();
        image.crossOrigin = 'anonymous';
        image.onload = () => {
            const canvas = document.createElement('canvas');
            const ctx = canvas.getContext('2d');
            canvas.height = image.naturalHeight;
            canvas.width = image.naturalWidth;
            ctx.drawImage(image, 0, 0);
            const dataUrl = canvas.toDataURL();
            callback && callback(dataUrl)
        }
        image.src = imgUrl;
    } else {       
        const data = await fetch(imgUrl);
        const blob = await data.blob();
        const reader = new FileReader();
        reader.readAsDataURL(blob);
        reader.onloadend = () => {
            const base64data = reader.result;            
            callback && callback(base64data)
        };
    }
}


export const shouldTaskAppearToday = (task: any, selectedDate: Date) => {
    enum weekDays { 'sunday', 'monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday' };
    let checkDate: Date = new Date(selectedDate);// checkDate.setHours(23, 59, 59);
    let startDate: Date = new Date(task.startDate);    
    let endRepeat = task.repeatData.repeatEnds ? new Date(task.repeatData.repeatTill) : null;

    if (endRepeat) {
        endRepeat.setHours(23, 59, 59);
    }

    if (!task.repeat) {
        return true;
    }

    let daysDiff = (new Date(checkDate.toLocaleDateString("af")).getTime() - new Date(startDate.toLocaleDateString("af")).getTime() )/ (1000 * 3600 * 24);  //Math.ceil((checkDate.valueOf() - startDate.valueOf()) / (1000 * 3600 * 24))
    if (daysDiff < 0) {
        
        return false;
    }

    //if repeat ends, we check if we should show it...
    if (endRepeat && (endRepeat.valueOf() - checkDate.valueOf()) < 0) {
        return false;
    }

    if (task.repeatData.repeatType === 'daily') {
        let diff = daysDiff % task.repeatData.repeatEvery;
        //if the diff between days passed and repeat every is exact, we know we have to show the task.
        if (diff==0) {
            return true;
        }
        return false;
    }

    if (task.repeatData.repeatType === 'weekly') {
        //we check to see if selectedDate week day is true or false...
        if (task.repeatData.repeatWeekDays[weekDays[checkDate.getDay()]]) {
            return true;
        }
        return false;
    }
}



const alertPolyfill = (title, description, options, extra) => {
    const result = window.confirm([title, description].filter(Boolean).join('\n'))

    if (result) {
        const confirmOption = options.find(({ style }) => style !== 'cancel')
        confirmOption && confirmOption.onPress()
    } else {
        const cancelOption = options.find(({ style }) => style === 'cancel')
        cancelOption && cancelOption.onPress()
    }
}

export const base64Encode = (input:string) =>{
    const chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=';
    let str = input;
    let output = '';

    for (let block = 0, charCode, i = 0, map = chars;
        str.charAt(i | 0) || (map = '=', i % 1);
        output += map.charAt(63 & (block >> (8 - (i % 1) * 8)))
    ) {
        charCode = str.charCodeAt(i += 3 / 4);
        if (charCode > 0xFF) {
            throw new Error("'base64Encode' failed: The string to be encoded contains characters outside of the Latin1 range.");
        }
        block = (block << 8) | charCode;
    }

    return output;
}

export const formatValueToDisplay = (value:any,fieldType:string="")=> {
    // Intenta convertir la cadena a número si es una cadena
    if (fieldType!="text" && typeof value === 'string' && !isNaN(value)) {
        value = Number(value); // Convierte la cadena a número
    }

    if (typeof value === 'number') {
        return value.toLocaleString(); // Formato con delimitador de miles
    } else if (typeof value === 'string') {
        return value; // Si es string, lo retorna tal cual
    } else if (value instanceof Date) {
        return value.toLocaleDateString(); // Si es fecha, lo formatea a una fecha
    }
    return value; // Si no es ninguno de los anteriores, lo retorna tal cual
}

export const formatNumber =( value, decimalPlaces = null, thousandSeparator = ",", decimalSeparator = ".") => {
    if (isNaN(value) || value === null) return "";
    let [integerPart, decimalPart] = value.toString().split(".");
    const formattedInteger = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, thousandSeparator);
    if (decimalPlaces !== null) {
        decimalPart = Number(`0.${decimalPart || 0}`).toFixed(decimalPlaces).split(".")[1];
    }
    return decimalPart !== undefined ? `${formattedInteger}${decimalSeparator}${decimalPart}` : formattedInteger;
}

export const mathjsEval = (formula:string, scope = {}) => {
    const ast = parse(formula);
    // función recursiva que convierte el AST en una expresión Decimal
    function transform(node: any): string {
    if (node.isConstantNode) {
      return `new Decimal(${node.value})`;
    }

    if (node.isSymbolNode) {
      if (scope[node.name] !== undefined) {
        return `new Decimal(${scope[node.name]})`;
      }
      return node.name; // si no está en scope, la dejamos como variable
    }

    if (node.isOperatorNode) {
      const [left, right] = node.args.map(transform);
      switch (node.op) {
        case "+": return `${left}.plus(${right})`;
        case "-": return `${left}.minus(${right})`;
        case "*": return `${left}.times(${right})`;
        case "/": return `${left}.div(${right})`;
        case "%": return `${left}.mod(${right})`;
        case "^": return `${left}.pow(${right})`;
        case "<": return `${left}.lt(${right})`;
        case "<=": return `${left}.lte(${right})`;
        case ">": return `${left}.gt(${right})`;
        case ">=": return `${left}.gte(${right})`;
        case "==": return `${left}.eq(${right})`;
        case "!=": return `${left}.neq(${right})`;
      }
    }

    if (node.isParenthesisNode) {
      return `(${transform(node.content)})`;
    }

    if (node.isConditionalNode) {
      const condition = transform(node.condition);
      const trueExpr = transform(node.trueExpr);
      const falseExpr = transform(node.falseExpr);
      return `(${condition}.isTrue ? ${trueExpr} : ${falseExpr})`;
      // 👆 podés definir `.isTrue` como quieras (ej: `.gt(0)` o `.toNumber() !== 0`)
    }

    throw new Error(`Nodo no soportado: ${node.type} : ${formula}`);
  }

  const exprDecimal = transform(ast);
  return eval(exprDecimal);
}
export const alert = Platform.OS === 'web' ? alertPolyfill : Alert.alert

export const getContrastTextColor = (hexcolor, fontDarkColor = "#000000", fontLightColor = "#FFFFFF") => {
    let hex = hexcolor.startsWith('#') ? hexcolor.slice(1) : hexcolor;
    if (hex.length === 3) {
        hex = hex[0] + hex[0] + hex[1] + hex[1] + hex[2] + hex[2];
    }
    if (hex.length !== 6) {
        console.error("Color HEX inválido. Debe tener 6 caracteres.");
        return "#000000"; 
    }
    const r = parseInt(hex.substring(0, 2), 16);
    const g = parseInt(hex.substring(2, 4), 16);
    const b = parseInt(hex.substring(4, 6), 16);
    const luminance = (r * 299 + g * 587 + b * 114) / 1000;
    const threshold = 128;

    return luminance > threshold ? fontDarkColor : fontLightColor;
}
